import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const location = useLocation();

    const getPageTitle = (pathname: string) => {
        switch (pathname) {
            case '/dashboard':
                return 'Dashboard';
            case '/students':
                return 'Student Management';
            case '/teachers':
                return 'Teacher Management';
            case '/staff':
                return 'Staff Management';
            case '/settings':
                return 'Settings';
            default:
                return 'Education Management System';
        }
    };

    return (
        <div className="h-screen bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50 flex overflow-hidden">
            <Sidebar
                isOpen={sidebarOpen}
                onClose={() => setSidebarOpen(false)}
                currentPath={location.pathname}
            />

            <div className="flex-1 flex flex-col min-w-0">
                <Header
                    onMenuClick={() => setSidebarOpen(true)}
                    title={getPageTitle(location.pathname)}
                />

                <main className="flex-1 overflow-y-auto p-6">
                    <div className="max-w-8xl mx-auto">
                        {children}
                    </div>
                </main>
            </div>
        </div>
    );
};

export default Layout;
